import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import UtilityBar from '@ux/utility-bar';

import '@ux/utility-bar/styles';

function UtilityBarClientWrapper(props) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const { customer = {} } = props;

  return (
    <>
      {isClient && <UtilityBar
        { ...props }
        { ...customer } />}
    </>
  );
}

export default UtilityBarClientWrapper;
UtilityBarClientWrapper.propTypes = {
  customer: PropTypes.object
};
